/**
 *
 * ModalCreateUser
 *
 */

import React, { Fragment } from "react"
import ModalDeleteSimple from "components/ModalDeleteSimple"
import { deleteAmbassadorApi } from "services/ambassador"

/* eslint-disable react/prefer-stateless-function */
class ModalAmbassadorDelete extends React.Component {
  state = { isLoading: false }

  sendServer = async () => {
    try {
      this.setState({ isLoading: true })
      const { currentAmbassador, deleteByDivision } = this.props
      const response = await deleteAmbassadorApi({
        id_ambassador: currentAmbassador.id_ambassador,
        id_division: deleteByDivision
          ? currentAmbassador.id_division
          : undefined,
      })
      this.props.onFinish()
      this.setState({ isLoading: false })
      returnMessage(response)
    } catch (e) {
      this.setState({ isLoading: false })
      returnMessage(e)
    }
  }

  render() {
    const { open, currentAmbassador } = this.props
    return (
      <ModalDeleteSimple
        visible={open}
        content={
          <Fragment>
            <p>
              <span>
                ¿Estás seguro de que deseas eliminar a{" "}
                {`${currentAmbassador.first_name}`} como embajador de{" "}
                {currentAmbassador.divisions &&
                currentAmbassador.divisions.length === 1 ? (
                  <span>{currentAmbassador.divisions[0].name}</span>
                ) : (
                  "las divisiones"
                )}
                ?
              </span>
            </p>
            <br />
            <p>
              Esto significará que el colaborador ya no podrá ver los resultados
              de la división ni ejecutar planes de acción.
            </p>
          </Fragment>
        }
        onOk={() => {
          this.sendServer()
        }}
        loading={this.state.isLoading}
        onCancel={() => this.props.onCancel()}
      />
    )
  }
}

export default ModalAmbassadorDelete
